<div [formGroup]="getFormGroup()" class="select-container">
  <label [for]="'slt_' + getId()" class="control-label bs-label th-text-main fw-bold"
    [class.bar-filter-label-margin]="getOneLineControl()">{{getLabelValue()}} <span class="required-span" *ngIf="getRequired()">*</span></label>

  <!-- Comobo box normal HTML -->
  <div *ngIf="!typeAhead">
    <select [formControlName]="getModelId()" [id]="'slt_' + getId()" #el class="form-control"
      [class.col-sm-10]="getOneLineControl()" [class.pull-right]="getOneLineControl()" [multiple]="getMultiple()"
      [required]="getRequired()" [disabled]="getReadOnly()">

      <option *ngIf="getIsLoading()" value="">Cargando...</option>
      <option *ngIf="getAnyOption() && !getIsLoading()" value="">Seleccione una opción</option>
      <option *ngFor="let opt of getOptions()" [value]="opt.value">{{opt.text}}</option>
    </select>
  </div>

  <!-- Combo box with search -->
  <div *ngIf="typeAhead">
    <div>
      <input autocomplete="off" class="form-control" type="text" id="typeAheadSearch" name="search" #search (focusin)="show()"
         (keyup)="filter()">
    </div>
    <div class="typeAhead-cont">
      <select (focusout)="hide()" (change)="selectOption()" class="typeAheadSelect" size="10" [id]="'slt_' + getId()" #el
        [formControlName]="getModelId()" [required]="getRequired()" [disabled]="getReadOnly()"> 
        <option *ngFor="let opt of getOptions()" [value]="opt.value">{{opt.text}}</option>
      </select>
    </div>
  </div>
</div>